import { Reveal, Overline } from "./Reveal";
import { BeforeAfterSlider } from "./BeforeAfterSlider";

const RESULTS = [
  { key: "carpet", title: "Carpet Cleaning", altBefore: "Illustrative example: soiled carpet with traffic lanes before professional cleaning", altAfter: "Illustrative example: the same carpet visibly cleaner after professional cleaning" },
  { key: "couch", title: "Couch & Lounge Cleaning", altBefore: "Illustrative example: stained couch upholstery before cleaning", altAfter: "Illustrative example: the same couch clean and refreshed after professional cleaning" },
  { key: "rug", title: "Rug Cleaning", altBefore: "Illustrative example: soiled rug before professional cleaning", altAfter: "Illustrative example: the same rug with colour and pile restored after cleaning" },
  { key: "mattress", title: "Mattress Cleaning", altBefore: "Illustrative example: mattress surface with visible staining before cleaning", altAfter: "Illustrative example: the same mattress visibly cleaner after professional cleaning" },
  { key: "tile", title: "Tile & Grout Cleaning", altBefore: "Illustrative example: tiled area with dark, grimy grout lines before cleaning", altAfter: "Illustrative example: the same tiled area with noticeably cleaner grout and tiles" },
  { key: "water", title: "Water Damage Restoration", altBefore: "Illustrative example: wet, water-affected carpet before restoration", altAfter: "Illustrative example: the same carpeted area dry, clean and restored-looking" },
];

export const RealResults = () => (
  <section data-testid="real-results-section" className="py-24 sm:py-32 bg-white border-y border-brand-line/50">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal className="max-w-2xl">
        <Overline>Before & After</Overline>
        <h2 className="mt-4 font-display font-medium text-4xl sm:text-5xl lg:text-6xl leading-[1.08] tracking-tight text-brand-ink">
          The Before & After <span className="font-serif italic text-brand">Difference</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-brand-muted leading-relaxed">
          Drag the slider to see the kind of transformation professional cleaning delivers.
        </p>
        <p className="mt-3 text-xs sm:text-sm text-brand-muted/80 leading-relaxed" data-testid="results-disclaimer">
          These examples use representative imagery to illustrate typical cleaning results —
          they are not photos of Kay's Carpet Cleaning customer jobs. Genuine job photos
          will be published here as they're collected.
        </p>
      </Reveal>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {RESULTS.map((r, i) => (
          <Reveal key={r.key} delay={0.05 * (i % 3)}>
            <figure>
              <BeforeAfterSlider
                beforeImage={`/images/ba/${r.key}-before.jpg`}
                afterImage={`/images/ba/${r.key}-after.jpg`}
                altBefore={r.altBefore}
                altAfter={r.altAfter}
                testId={`results-slider-${r.key}`}
              />
              <figcaption className="mt-4 px-1 font-display font-medium text-brand-ink" data-testid={`results-caption-${r.key}`}>
                {r.title}
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
